'use client';

import React, { useContext, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import styles from './popularTopicsContainer.module.scss';
import SectionPanel from './sectionPanel';
import { useTrack } from '@chewy/use-analytics';
import { useParams } from 'next/navigation';
import OHCContext from '@/providers/OHCContext';
import { KibSectionHeading } from '@chewy/kib-content-groups-react';
import '@chewy/kib-content-groups-styles/dist/styles/kib-section-heading.css';
export interface PopularTopicsContainerProps {
  isRX?: boolean;
}

const PopularTopicsContainer = ({ isRX }: PopularTopicsContainerProps) => {
  const { popularTopics } = useContext(OHCContext);

  const params = useParams();
  const id = params.id as string[] | string;
  const track = useTrack();

  useEffect(() => {
    track(`${isRX ? 'RX' : ''} Popular Topics Widget Viewed`, {
      id: 'popular-topics-page-viewed-id',
      parentId: id,
      level: 'help-center',
      type: 'section',
      position: 1,
      event_name: 'Widget Viewed',
      eventAction: 'impression',
      eventCategory: 'help-center-landing-page',
      eventLabel: 'help-center-landing-page-popular-topics-view',
      name: 'Popular Topics Widget Viewed'
    });
  }, [track, popularTopics, isRX, id]);

  if (isEmpty(popularTopics)) {
    return null;
  }

  return (
    <div role="main" aria-label="Help Center Topics">
      <KibSectionHeading
        heading={popularTopics.title}
        key={popularTopics.id}
        className={styles.popularTopicsSection}
        aria-labelledby={`section-${popularTopics.id}`}
        aria-label={`${popularTopics.title} topics`}
      >
        {!isEmpty(popularTopics?.sections) && (
          <ul className={styles.linkList} role="list" aria-labelledby={`section-${popularTopics.id}`} aria-label={`${popularTopics.title} topics`}>
            {map(popularTopics?.sections, (section: any) => (
              <SectionPanel key={section?.id} section={section} popularTopic={isRX ? 'rx-popular' : 'popular'} />
            ))}
          </ul>
        )}
      </KibSectionHeading>
    </div>
  );
};

export default PopularTopicsContainer;
